window.ResumeUploadForm = function (scope, Upload, applicationId, hUser, job, bulk, userLocation ) {
    var self = this;
    var formName = "resume-upload-form";
    var _protected = BaseForm.call(self, formName, scope);
    var savePromise;

    self.data.files = [];
    self.user_id = hUser.getUser().id;
    self.application_id = applicationId;
    self.job = job;
    if (bulk) {
        self.jobLocation = [userLocation];
    } else {
        self.jobLocation = self.job.JobLocation;
    }

    self.save = function() {

        var defer = $q.defer();

        // if upload is in progress wait for save form until upload is resolved or rejected
        if (self.profile_resume_progress === IN_PROGRESS) {
            savePromise = defer;
        }
        else {
            if (self.data.files[0] && self.data.files[0].needs_assign) {
                var userResume = self.data.files[0];

                JobApplicationAPI.assignAppResume(applicationId, userResume.id)
                    .then(function () {
                        defer.resolve();
                    }, function (error) {
                        defer.reject(error);
                    });
            }
            else {
                defer.resolve();
            }
        }

        return defer.promise;
    };

    self.load = function () {

    };

    self.getPreparedData = function () {
        return self.resumeURL;
    };

    self.validator.validateCustom = function (field, optionsField, rule, showError) {

        var value = self.data.files;
        self.validator.validation['resume-upload'] = { errors: {}};

        switch (rule.name) {
            case 'required_files':

                var dependency = self.required;
                if (dependency && !value.length) {
                    if (showError) {
                        self.validator.validation['resume-upload']['errors']['required_files'] = true;
                    }
                    return false;
                } else {
                    self.validator.validation['resume-upload'] = { errors: {}};
                }

                break;
        }

        return true;
    };

    self.onFileSelect = function (files, doParse) {
        if (files && files[0]) {
            self.needsUpload = false;

            var nameParts = files[0].name.split(".");
            var fileExtension = nameParts[(nameParts.length - 1)].toLowerCase();

            if (['doc', 'pdf', 'docx', 'txt', 'rtf'].indexOf(fileExtension) > -1) {
                self.data.files = files;
                self.validator.validation['resume-upload'] = { 'errors': {} };

                if (self.validator.validate()) {
                    if (self.application_id || bulk) {
                        uploadResume(doParse);
                    }
                    else {
                        self.needsUpload = true;
                    }
                }
            }
            else {
                hAlert(
                    $filter("translate")("Invalid file type"),
                    $filter("translate")("Supported types are:") + " docx, doc, pdf, txt, rtf"
                );
            }
        }
    };

    self.setRequired = function (isRequired) {
        self.required = isRequired;
    };

    self.allowParse = function (parseResume) {
        self.parseAllowed = parseResume;
    };

    self.setImplicitParse = function (fillUserProfile) {
        self.fill_user_profile = !!fillUserProfile;
    };

    self.getParsedData = function () {
        console.warn("Override this function");
    };

    var DONE = "DONE";
    var NTHN = "NTHN";
    var ERROR = "ERROR";
    var IN_PROGRESS = "IN_PROGRESS";
    self.profile_resume_progress = NTHN;
    self.resume_progress = 0;
    self.resume_upload_error_message = null;

    const uploadResume = async (doParse) => {
        self.profile_resume_progress = IN_PROGRESS;
        let parse = (typeof(doParse) === 'boolean')? doParse: true;
        let $resumeParseModal;

        if (parse) {
            $resumeParseModal = $("#resume_parse_modal");

            if ($resumeParseModal.length === 1) {
                $resumeParseModal.modal({
                    backdrop: 'static',
                    keyboard: false,
                    show: true
                });
            }
            else {
                console.error("There should be exactly one resume parse modal in the view, found:", $resumeParseModal.length);
            }
        }
        if (bulk) {
            JobApplicationAPI.getResumeUrl()
                .then(function (res) {
                    Upload.http({
                        'url': res.href,
                        'method': 'PUT',
                        'headers': {
                            'Content-Type': ''
                        },
                        'Content-Type': '',
                        'data': self.data.files[0]
                    }).progress(function (evt) {
                        self.resume_progress = parseInt(100.0 * evt.loaded / evt.total);
                    }).success(function (data, status, headers, config) {
                        // file is uploaded successfully
                        self.profile_resume_progress = DONE;
                        self.resume_progress = 0;
                        self.resumeURL = res.href;
                        savePromise && savePromise.resolve(data);
                        $resumeParseModal && $resumeParseModal.modal('hide');
                    }).error(function (reason) {
                        $resumeParseModal && $resumeParseModal.modal('hide');
                        reason = reason || {error: 'Failed to upload resume', code: 'RESUME_FAIL'};
                        console.error("Error while parsing:", reason);
                        savePromise && savePromise.reject(reason);
                        onRequestError();
                    });
                })
                .catch(function (reason) {
                    $resumeParseModal && $resumeParseModal.modal('hide');
                    reason = reason || {error: 'Failed to upload resume', code: 'RESUME_FAIL'};
                    console.error("Error while parsing:", reason);
                    savePromise && savePromise.reject(reason);
                    onRequestError();
                });

        } else {
            const dataObject = {
                file: self.data.files[0],
                parse: parse,
                fill_user_profile: self.fill_user_profile
            };

            let isLoggedIn = hUser.isLoggedIn();
            if (isLoggedIn) {
                HStorageManager.remove({
                    storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                    key: 'placeholder_token'
                });
            }
            const placeholderToken = HStorageManager.get({
                storageLevel: HStorageManager.StorageLevels.LOCAL_STORAGE,
                key: 'placeholder_token'
            });
            if (placeholderToken) {
                dataObject.placeholder_token = placeholderToken;
            }

            Upload.upload({
                url: publicConfiguration.APIServerBaseURL.replace('v1', 'v2') + 'applications/' + self.application_id + '/resume',
                withCredentials: true,
                headers: {},
                method: 'POST',
                data: dataObject,
                'Content-Type': 'multipart/form-data'
            }).progress(function (evt) {
                self.resume_progress = parseInt(100.0 * evt.loaded / evt.total);

            }).success(function (data, status, headers, config) {
                // file is uploaded successfully
                if (data.status_code == 200) {
                    self.profile_resume_progress = DONE;
                    self.resume_progress = 0;
                    if (data.data && data.data.resume) {
                        var resume = data.data.resume;
                        self.data.files = [
                            {
                                name: resume.display_name + '.' + resume.extension,
                                extension: resume.extension,
                                file_name: resume.file_name,
                                id: resume.id,
                                href: resume.href
                            }
                        ];
                    }
                    if (parse) {
                        mapDataAfterParse(data.data.parsing_results);
                    }
                    savePromise && savePromise.resolve(data);
                }
                else {
                    self.data.files = [];
                    console.error("Error while parsing:", data);
                    savePromise && savePromise.reject(data);
                    onRequestError();
                }

                $resumeParseModal && $resumeParseModal.modal('hide');
            })
                .error(function (reason) {
                    $resumeParseModal && $resumeParseModal.modal('hide');
                    reason = reason || {error: 'Failed to upload resume', code: 'RESUME_FAIL'};
                    console.error("Error while parsing:", reason);
                    savePromise && savePromise.reject(reason);
                    onRequestError();
                });
        }
    };

    self.uploadResume = uploadResume;

    self.setApplicationId = function (applicationId) {
        self.application_id = applicationId;
    };

    const onRequestError = () => {
        self.resume_progress = 0;
        self.profile_resume_progress = ERROR;
        self.resume_upload_error_message = $filter("translate")("Something went wrong with your resume parsing!");
    };

    var mapDataAfterParse = function (parsedData) {
        var mappedData = {};
        if (parsedData) {

            var work_history = [];
            for (var i in parsedData.work_history) {
                if (!_.isEmpty(parsedData.work_history[i])) {
                    work_history.push(parsedData.work_history[i]);
                }
            }
            mappedData['work_history'] = work_history;

            var education = [];
            for (var i in parsedData.education) {
                if (!_.isEmpty(parsedData.education[i])) {
                    education.push(parsedData.education[i]);
                }
            }
            mappedData['education'] = education;

            if (parsedData.personal) {
                mappedData['phone'] = parsedData.personal.phone;
            }

            var references_array = [];
            if (parsedData.references && parsedData.references.length) {
                for (var i in parsedData.references) {
                    var reference = {
                        name: parsedData.references[i]
                    };
                    references_array.push(reference);
                }
            }

            mappedData['references'] = references_array;
            mappedData['skills'] = parsedData.skills;
        }

        self.getParsedData(mappedData);
    }
};